import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import './index.css';
import {createNamespace} from '../../common/utils';
import {getComponentName} from '../../common/utils/namespace';
import Model from './model';
import Dayjs from 'dayjs';

var _createNamespace = createNamespace('countdown'),
    _createNamespace2 = _slicedToArray(_createNamespace, 1),
    b = _createNamespace2[0];

function formatNum(num) {
    return (num >= 10 ? '' : '0') + num;
}

export default {
    name: getComponentName('Countdown'),
    props: {
        time: {
            type: [String, Number],
            default: 0
        },
        format: {
            type: [String],
            default: 'HH:mm:ss'
        },
        manual: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        time: function time(after) {
            this.model.setCurrent(after);
        }
    },
    data: function data() {
        return {
            textDisplay: '',
            timeData: null,
            model: new Model({
                time: parseInt(this.time)
            })
        };
    },
    created: function created() {
        var _this = this;

        var timeHandler = function timeHandler(_ref) {
            var value = _ref.value;
            var start = Dayjs('2000-01-01 00:00');
            var end = start.add(value, 'ms');
            var days = end.diff(start, 'day');
            var hours = end.diff(start, 'hour') - end.diff(start, 'day') * 24;
            var minutes = end.diff(start, 'minute') - end.diff(start, 'hour') * 60;
            var seconds = end.diff(start, 'second') - end.diff(start, 'minute') * 60;
            var valueObj = {
                DD: formatNum(days),
                HH: formatNum(hours),
                mm: formatNum(minutes),
                ss: formatNum(seconds)
            };
            _this.timeData = Object.assign(Object.assign({}, valueObj), {
                days: days,
                hours: hours,
                minutes: minutes,
                seconds: seconds
            });
            _this.textDisplay = Object.entries(valueObj).reduce(function(text, _ref2) {
                var _ref3 = _slicedToArray(_ref2, 2),
                    key = _ref3[0],
                    value = _ref3[1];

                return text.replace(key, value);
            }, _this.format);

            _this.$emit('update', valueObj);
        };

        this.model.on('update', timeHandler);
        this.model.setCurrent();
        this.model.on('timeout', function() {
            _this.$emit('timeout');
        });
        this.start();
    },
    beforeDestroy: function beforeDestroy() {
        this.model.destroy();
    },
    render: function render() {
        var h = arguments[0];
        return h(
            'div',
            {
                class: b()
            },
            [this.$scopedSlots.default ? this.$scopedSlots.default(this.timeData) : this.textDisplay]
        );
    },
    methods: {
        reset: function reset() {
            this.model.reset();
        },
        start: function start() {
            this.model.start();
        },
        pause: function pause() {
            this.model.pause();
        }
    },
    install: function install(Vue) {
        Vue.component(this.name, this);
    }
};
